import { render, staticRenderFns } from "./LegalDocumentContent_w5cHV7.vue?vue&type=template&id=500ffb68&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_w5cHV7.vue?vue&type=style&index=0&id=500ffb68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500ffb68",
  null
  
)

export default component.exports